









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BaseVue } from "../../base";

@Component
export class RatingItem extends BaseVue {
  @Prop() item: any;

  constructor() {
    super();
  }
  getModel() {
    return this.item;
  }
}

Vue.component("sv-rating-dropdown-item", RatingItem);
export default RatingItem;
